import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { ModalProps } from "../../types/modal";
import { useL10nContext } from "../../util/contexts";
import CloseIcon from "../../Assets/svg/Close_x_icon";
import "./modal.scss";

const Modal = (props: ModalProps) => {
    const { decodeModalL10n } = useL10nContext();
    const l10n = decodeModalL10n();

    const overlayClassNames = `ssw-modal-overlay ${props.tenant} ${props.parentName} visible`;
    const wrapperTabNavAttributes = { modal: "true", group: "true" };
    const confirmBtnTabNavAttributes = { focusable: true, order: "1" };
    const closeBtnTabNavAttributes = { focusable: true, order: "0" };

    const confirmButtonRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        if (props.open && confirmButtonRef.current) {
            shell?.tabNav.focus(confirmButtonRef.current);
        }
    }, [props.open]);

    if (!props.open) return null;

    return createPortal(
        <div className={overlayClassNames}>
            <div
                className="ssw-modal"
                role="dialog"
                aria-modal="true"
                aria-label={l10n.dataIncomplete}
                {...wrapperTabNavAttributes}
            >
                <button
                    className="close-btn"
                    aria-label={l10n.labelClose}
                    onClick={props.onClose}
                    {...closeBtnTabNavAttributes}
                >
                    <CloseIcon />
                </button>

                <p className="ssw-modal-header">{l10n.dataIncomplete}</p>
                <hr className="ssw-modal-line" />
                <div className="ssw-modal-body">
                    <p className="text">{l10n.enterSearchTerm}</p>
                    <br />
                </div>
                <button
                    ref={confirmButtonRef}
                    className="confirm-btn"
                    type="submit"
                    aria-label={l10n.labelOk}
                    onClick={props.onClose}
                    {...confirmBtnTabNavAttributes}
                >
                    {l10n.labelOk}
                </button>
            </div>
        </div>,
        document.body
    );
};

export default Modal;
